import React from "react";
import { Typography } from "antd";
const { Text } = Typography;
import { withTranslation } from "react-i18next";
import { useGetSetting } from "../../hooks/getSetting";

const PatientPageCount = ({ t, range, total, isAccurateCount, isEnrollment = false, titleKey }) => {
  const [treshold] = useGetSetting(["dashboard.max-count-result-threshold"]);

  const totalDisplay = isAccurateCount
    ? total
    : t("patients_pagination.many_patients", { max_count_treshold: treshold });
  const title = titleKey ? t(titleKey) : isEnrollment ? t("enrollments") : t("patients");

  return (
    <>
      <Text>
        {t("patients_pagination.showing_range", {
          range_start: range[0],
          range_end: range[1] ? range[1] : range[0],
          total: totalDisplay
        })}{" "}
        <Text strong>{title}</Text>
      </Text>
    </>
  );
};

export default withTranslation()(PatientPageCount);
